// import { useNavigate } from "react-router-dom";

export const StartEarning = () => {
  // const navigation = useNavigate();

  // const onEnterApp = () => {
  //   navigation("/dapp");
  // };
  return (
    <a
      href="https://t.me/omeaapp"
      target="_blank"
      rel="noreferrer"
      className="btn btn-lg btn-primary"
    >
      <strong>Join Community</strong>
    </a>
    // <button onClick={onEnterApp} className="btn btn-lg btn-primary">
    //   <span className="start-earning">
    //     <strong>Start Earning </strong>
    //   </span>
    // </button>
  );
};
